module.exports = __webpack_public_path__ + "img/mdtp_logo.858cce3c.png";